<template>
  <span>
    <autocomplete v-model="searchQuery" :options="options" :on-item-selected="onSearchItemSelected" :on-input-change="onInputChange" :required="required">
      <template #item="props">
       <strong>{{(props.item.external_id || '') | cleanentityprefix}}</strong> {{props.item.name | cleanentityprefix}} {{ props.item.reference_location ? `(${props.item.reference_location})` : ''}}
      </template>
    </autocomplete>
    <span v-b-tooltip.html v-if="hasErrors" :title="hasErrorsMessage || 'null'">
      <font-awesome-icon icon="exclamation-triangle" class="text-warning" />
    </span>
    <geofences-list-item-fence :geofence="selectedSearchItem || previewData" button-type="badge" v-if="withPreview && (selectedSearchItem || previewData)">
      <template #button-content>
        <i class='fas fa-eye'></i>
        <translate>Preview</translate>
      </template>
    </geofences-list-item-fence>
  </span>
</template>

<script>
import Autocomplete from '@/components/Autocompletes/Autocomplete'
import GeofencesListItemFence from '@/components/Geofences/ListItemFence'

export default {
  name: 'GeofenceAutocomplete',
  components: {
    Autocomplete,
    GeofencesListItemFence
  },
  props: {
    preQuery: {
      type: String,
      default: null
    },
    minCharacter: {
      type: Number,
      default: 3
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    restrictToLevels: {
      type: Array,
      default: () => []
    },
    restrictTo: {
      type: Array,
      default: () => []
    },
    includes: {
      type: Array,
      default: () => ['geo_type']
    },
    withPreview: {
      type: Boolean,
      default: false
    },
    previewData: {
      type: Object
    },
    checkFor: {
      type: [Array, Function]
    },
    hasErrorsMessage: {
      type: String
    },
    selectedSearchItemProp: {
      type: [String, Object]
    }
  },
  data() {
    return {
      searchQuery: '',
      selectedSearchItem: null,
      options: {
        debounce: 500,
        placeholder: this.placeholder,
        inputClass: 'form-control'
      },
      currentMssgClass: 'left',
      profilePictureSize: '50',
      hasErrors: false
    }
  },
  watch: {
    preQuery(val, oldVal) {
      if (val !== oldVal) {
        this.searchQuery = this.$options.filters.cleanentityprefix(val) || ''
      }
    },
    selectedSearchItemProp(val, oldVal) {
      if (val !== oldVal) {
        this.onSearchItemSelected(val)
      }
    }
  },
  created() {
    if (!this.placeholder) {
      this.options.placeholder = this.$gettext('Name, Reference Location, or External ID')
    }
  },
  methods: {
    onInputChange(query) {
      const params = {
        includes: this.includes,
        sort: [
          {
            key: 'name',
            direction: 'asc'
          },
          {
            key: 'id',
            direction: 'asc'
          }
        ],
        filter_groups: [
          {
            or: true,
            filters: [
              ['reference_location', 'sw', query.trim()],
              ['name', 'ct', query.trim()],
              ['external_id', 'ct', query.trim()]
            ]
          }
        ]
      }
      if (this.restrictToLevels.length > 0) {
        params.filter_groups.push({
          filters: [
            ['geo_type.level', 'in', this.restrictToLevels]
          ]
        })
      }

      if (Array.isArray(this.restrictTo) && this.restrictTo.length > 0) {
        params.filter_groups.push({
          filters: this.restrictTo
        })
      }

      if (query.trim().length >= this.minCharacter) {
        return new Promise(resolve => {
          this.$http.get(this.$appConfig.api.baseUrl + 'geo-fences', { params })
            .then(response => {
              resolve(response.body.data)
            })
        })
      }
    },
    onSearchItemSelected(item) {
      this.searchQuery = this.$options.filters.cleanentityprefix(item.external_id) || item.name || item.id
      this.selectedSearchItem = item
      if (this.checkFor && Array.isArray(this.checkFor)) {
        for (const field of this.checkFor) {
          if (!this.selectedSearchItem[field] || this.selectedSearchItem[field].length === 0) {
            this.hasErrors = true
          }
        }
      } else if (this.checkFor && typeof this.checkFor === 'function') {
        this.hasErrors = !this.checkFor(this.selectedSearchItem)
      }
      this.$emit('selected', item)
    }
  }
}
</script>
